import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b9e2fb22")

_pushScopeId("data-v-b9e2fb22")
const _hoisted_1 = {
  class: "justify-between",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  class: "justify-between",
  style: {"margin-bottom":"20px"}
}
const _hoisted_5 = {
  class: "justify-between",
  style: {"margin-bottom":"10px"}
}
const _hoisted_6 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_transfer = _resolveComponent("el-transfer")
  const _component_custom_form_item = _resolveComponent("custom-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock(_component_el_form, {
    ref: "formRef",
    rules: _ctx.rules,
    model: _ctx.formData
  }, {
    default: _withId(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.formData.relay, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          key: `relay${index}`,
          style: {"padding-top":"20px","border-top":"1px dashed gray"}
        }, [
          _createVNode("div", _hoisted_1, [
            _createVNode("span", null, [
              _createVNode("b", null, _toDisplayString(_ctx.$wordList.ProperAllTextRelay) + _toDisplayString(index+1), 1)
            ]),
            _createVNode(_component_el_switch, {
              disabled: item.enable.disabled,
              "active-text": _ctx.$wordList.ProperAllTextOn,
              "inactive-text": _ctx.$wordList.ProperAllTextOff,
              modelValue: item.enable.value,
              "onUpdate:modelValue": ($event: any) => (item.enable.value = $event),
              "active-color": "#20a0ff",
              "inactive-color": "#fb602a",
              "active-value": 1,
              "inactive-value": 0,
              onChange: _cache[1] || (_cache[1] = (val)=>{_ctx.changeRelayEnable(val,'relay')})
            }, null, 8, ["disabled", "active-text", "inactive-text", "modelValue", "onUpdate:modelValue"])
          ]),
          (item.enable.value)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.FormRelayName,
                  prop: `relay[${index}].name.value`
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.relay[index].name.value,
                      "onUpdate:modelValue": ($event: any) => (_ctx.formData.relay[index].name.value = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]),
                _withDirectives(_createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.FormDTMFCode,
                  prop: `relay[${index}].dtmf.showSmartPlusTalkingLimitTip`
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: item.dtmf.value,
                      "onUpdate:modelValue": ($event: any) => (item.dtmf.value = $event),
                      class: "width100per",
                      onChange: _cache[2] || (_cache[2] = (val)=>{_ctx.changeDtmf(val,'relay')})
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dtmfCodeList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]), [
                  [_vShow, item.dtmf.show]
                ]),
                (item.unlock.show)
                  ? _withDirectives((_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: _ctx.$wordList.NavInHtmlMenuAccess
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.unlockMethodList, (el) => {
                          return _withDirectives((_openBlock(), _createBlock(_component_el_checkbox, {
                            "true-label": 1,
                            "false-label": 0,
                            key: el.label,
                            modelValue: item.unlock[el.value].value,
                            "onUpdate:modelValue": ($event: any) => (item.unlock[el.value].value = $event),
                            onChange: _cache[3] || (_cache[3] = (val)=>{_ctx.changeUnlockCheckbox(val,'relay')})
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(el.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"])), [
                            [_vShow, item.unlock[el.value].show]
                          ])
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["label"])), [
                      [_vShow, item.unlock.show]
                    ])
                  : _createCommentVNode("", true),
                (item.schedule.show)
                  ? (_openBlock(), _createBlock("div", _hoisted_3, [
                      _createVNode("div", _hoisted_4, [
                        _createVNode("span", null, [
                          _createVNode("b", null, _toDisplayString(_ctx.$wordList.HoldOpenTime), 1)
                        ]),
                        _createVNode(_component_el_switch, {
                          "active-text": _ctx.$wordList.ProperAllTextOn,
                          "inactive-text": _ctx.$wordList.ProperAllTextOff,
                          modelValue: item.schedule.enable,
                          "onUpdate:modelValue": ($event: any) => (item.schedule.enable = $event),
                          "active-color": "#20a0ff",
                          "inactive-color": "#fb602a",
                          "active-value": 1,
                          "inactive-value": 0
                        }, null, 8, ["active-text", "inactive-text", "modelValue", "onUpdate:modelValue"])
                      ]),
                      (item.schedule.enable)
                        ? (_openBlock(), _createBlock(_component_custom_form_item, {
                            key: 0,
                            prop: `relay[${index}].schedule.access`
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_transfer, {
                                filterable: "",
                                modelValue: item.schedule.access,
                                "onUpdate:modelValue": ($event: any) => (item.schedule.access = $event),
                                "filter-placeholder": _ctx.$wordList.ProperAllTextAccessGroupName,
                                "button-texts": [_ctx.$wordList.ProperAllTextRemove,_ctx.$wordList.FormAdd],
                                titles: [_ctx.$wordList.ProperAllTextToBeSelected, _ctx.$wordList.ProperAllTextSelected],
                                data: _ctx.accessGroupListForRelayScheduleList[index],
                                props: {
                                key: 'ID',
                                label: 'Name',
                            }
                              }, {
                                default: _withId(({ option }) => [
                                  _createVNode("span", {
                                    title: option.Name
                                  }, _toDisplayString(option.Name), 9, ["title"])
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue", "filter-placeholder", "button-texts", "titles", "data"])
                            ]),
                            _: 2
                          }, 1032, ["prop"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.formData.securityRelay, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          key: `securityRelay${index}`,
          style: {"padding-top":"20px","border-top":"1px dashed gray"}
        }, [
          _createVNode("div", _hoisted_5, [
            _createVNode("span", null, [
              _createVNode("b", null, _toDisplayString(_ctx.$wordList.SecurityRelay) + _toDisplayString(index+1), 1)
            ]),
            _createVNode(_component_el_switch, {
              disabled: item.enable.disabled,
              "active-text": _ctx.$wordList.ProperAllTextOn,
              "inactive-text": _ctx.$wordList.ProperAllTextOff,
              modelValue: item.enable.value,
              "onUpdate:modelValue": ($event: any) => (item.enable.value = $event),
              "active-color": "#20a0ff",
              "inactive-color": "#fb602a",
              "active-value": 1,
              "inactive-value": 0,
              onChange: _cache[4] || (_cache[4] = (val)=>{_ctx.changeRelayEnable(val,'securityRelay')})
            }, null, 8, ["disabled", "active-text", "inactive-text", "modelValue", "onUpdate:modelValue"])
          ]),
          (item.enable.value)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.FormRelayName,
                  prop: `securityRelay[${index}].name.value`
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: item.name.value,
                      "onUpdate:modelValue": ($event: any) => (item.name.value = $event),
                      "auto-complete": "off"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]),
                _withDirectives(_createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.FormDTMFCode,
                  prop: `securityRelay[${index}].dtmf.showSmartPlusTalkingLimitTip`
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: item.dtmf.value,
                      "onUpdate:modelValue": ($event: any) => (item.dtmf.value = $event),
                      class: "width100per",
                      onChange: _cache[5] || (_cache[5] = (val)=>{_ctx.changeDtmf(val,'securityRelay')})
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dtmfCodeList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]), [
                  [_vShow, item.dtmf.show]
                ]),
                (item.unlock.show)
                  ? _withDirectives((_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: _ctx.$wordList.NavInHtmlMenuAccess
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.unlockMethodList, (el) => {
                          return _withDirectives((_openBlock(), _createBlock(_component_el_checkbox, {
                            "true-label": 1,
                            "false-label": 0,
                            onChange: _cache[6] || (_cache[6] = (val)=>{_ctx.changeUnlockCheckbox(val,'securityRelay')}),
                            key: el.label,
                            modelValue: item.unlock[el.value].value,
                            "onUpdate:modelValue": ($event: any) => (item.unlock[el.value].value = $event)
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(el.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"])), [
                            [_vShow, item.unlock[el.value].show]
                          ])
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["label"])), [
                      [_vShow, item.unlock.show]
                    ])
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (_ctx.relayAddBtnShow)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            size: "medium",
            onClick: _ctx.addRealy
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextAddRelay), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.securityRelayAddBtnShow)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            size: "medium",
            onClick: _ctx.addSecurityRealy
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$wordList.AddSecurityRelay), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["rules", "model"]))
})